import {
  PromotionRewardItemCreateRequestType,
  PromotionRewardItemCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const usePromotionRewardItemCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: PromotionRewardItemCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: "promotion-reward-items",
        data,
      }).then(
        (data) =>
          apiV2AssertResponse<PromotionRewardItemCreateResponseType>(data).data,
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.Promotions],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PromotionRewardItems],
      });
    },
  });
};
